<template>
  <div>
    <div class="page-header clear-filter" filter-color="">
      <parallax
        class="page-header-image"
        style="background-image: url('https://systembe.tef.co.id//storage/banner_content/welding.jpg')"
      >
      </parallax>
      <div class="container">
        <h2 class="title mt-5">{{ $t('detailBlog.pageTitle') }}</h2>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <router-link to="/blog" class="back-to-blog animated fadeInDown">
          <i class="fa fa-arrow-left mr-2"></i>{{ $t('detailBlog.backToList') }}
        </router-link>
        <div class="row mt-4">
          <div class="col-lg-9">
            <div class="article-image animated fadeInDown">
              <img :src="storageUrl+'banner_content/'+banner" :alt="title" />
            </div>
            <div class="article-meta">
              <span class="article-date"><i class="fa fa-calendar mr-2"></i>{{ moment(created_at).locale($i18n.locale).format('LL') }}</span>
              <span class="article-author"><i class="fa fa-user mr-2"></i>{{ $t('blog.byAdmin') }}</span>
            </div>
            <h2 class="article-title font-weight-bold text-dark">{{ title }}</h2>
            <hr class="article-divider">
            <div class="article-body" style="white-space: pre-wrap;" v-html="description"></div>
          </div>
          <div class="col-lg-3">
            <div class="sidebar-card animated fadeInDown">
              <h6 class="sidebar-title font-weight-bold text-dark">
                <span class="sidebar-title-bar"></span>{{ $t('detailBlog.sidebar.title') }}
              </h6>
              <router-link
                v-for="(row, i) in table.data"
                :key="i"
                :to="/detail-blog/+row.code"
                class="related-post"
              >
                <img :src="storageUrl+'banner_content/'+row.banner" :alt="row.title" class="related-post-thumb" />
                <div class="related-post-body">
                  <span class="related-post-title">{{ truncate(row.title, 55) }}</span>
                  <span class="related-post-date">{{ moment(row.created_at).locale($i18n.locale).format('LL') }}</span>
                </div>
              </router-link>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- MOTO TOKKI  -->
    <div class="page-header clear-filter mt-5 moto-office-section" filter-color="purple">
      <div class="parallax">
        <div class="container" style="">
          <h1 class="text-white text-left pt-5 font-weight-bold text-center">START <span style="font-size: 20px; color: yellow;"> {{ $t('common.offices.motoStartWithTokki') }} </span></h1>
          <div class="row pt-5">
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.mainOfficeFactory') }}</span></h6>
              Kawasan Industri Jababeka 1
              Jl.Jababeka XIIB Blok W26
              Cikarang-Bekasi, Jawa Barat Indonesia Kode Pos 17530
              Telp: +62-21 893 6733 (Hunting) <br><br>

              Phone : +62 - 21 8936733 (Hunting)<br>
              Fax   : +62 - 21 8936738<br>
              Email : sales@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.secondOfficeFactory') }}</span></h6>
              Kawasan Industri Krakatau 1,
              Jl. Australia I Kav. C1/2, Kel. Warnasari, Kec. Citangkil
              Kota Cilegon, Banten - Indonesia 42443 <br><br>

              Phone : +62 - 254 8317244<br>
              Fax   : +62 - 254 8317244<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.thirdOfficeFactory') }}</span></h6>
              Green Garden, Blok A-4 No. 01 Jl. Dr. Wahidin Sudirohusodo Kel. Dahanrejo, Kec. Kebomas Gresik, Jawa Timur, Indonesia 61124 <br><br>

              Phone : +62 - 31 39935914<br>
              Fax   : +62 - 31 39935914<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left mb-5">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.fourthMarketingOffice') }}</span></h6>
              Jl. Gn. Leuser, Tj. Marulak, Kec. Rambutan, Kota Tebing Tinggi, Sumatera Utara 20998 <br><br><br>

              Phone : +62 811-1972-2507<br>
              Email : sales@tef.co.id<br>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { Carousel, CarouselItem } from 'element-ui';
import config from '@/configs/config';
import Api from '@/helpers/api';
var moment = require('moment');
import blog from '@/services/blog.service';
import { updateArticleHead } from '@/utils/head';

export default {
  name: 'profile',
  bodyClass: 'profile-page',
  components: {
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },
  data () {
    return {
      moment:moment,
      form: {
        add: true,
        title: "",
        show: false
      },
      banner: '',
      title: '',
      description: '',
      created_at: '',
      table: {
        data: []
      },
      search: {
        position: '',
        level: '',
        location: '',
        requirements: '',
        status: '',
      },

      storageUrl : config.blogStorageUrl,

    }
  },
  mounted(){
    this.getDetailBlog();
    this.getBlog();
  },
  watch: {
    '$route.params.code'() {
      this.getDetailBlog();
    }
  },
  methods: {
    getDetailBlog(param){
      let context = this;
      Api(context, blog.show(context.$route.params.code)).onSuccess(function(response) {
          context.banner      = response.data.data.banner;
          context.title       = response.data.data.title;
          context.description = response.data.data.description;
          context.created_at  = response.data.data.created_at;
          updateArticleHead({
            title: context.title,
            description: context.description,
            imageUrl: context.banner ? context.storageUrl + 'banner_content/' + encodeURIComponent(context.banner) : '',
          });
      }).onError(function(error) {
      })
      .call()
    },
    getBlog(param){
      let context = this;
      Api(context, blog.index()).onSuccess(function(response) {
          context.table.data = response.data.data.data.slice(0, 10);
      }).onError(function(error) {
          context.table.data = [];
      })
      .call()
    },
    toDetailProduct(param){
      this.$router.push('/detail-product/'+param)
    },
    truncate(str, max) {
      if (!str) return "";
      // handle multi-byte chars safely
      const s = Array.from(str).slice(0, max).join("");
      return s.length < str.length ? s + "…" : s;
    },
  }
};
</script>
<style>
   .animated {
     
      padding-top:0px;
      margin-bottom:0px;
      -webkit-animation-duration: 5s;
      animation-duration: 5s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
   }
   
   @-webkit-keyframes fadeInDown {
      0% {
         opacity: 0;
         -webkit-transform: translateY(-20px);
      }
      100% {
         opacity: 1;
         -webkit-transform: translateY(0);
      }
   }
   
   @keyframes fadeInDown {
      0% {
         opacity: 0;
         transform: translateY(-50px);
      }
      100% {
         opacity: 1;
         transform: translateY(0);
      }
   }
   
   .fadeInDown {
      -webkit-animation-name: fadeInDown;
      animation-name: fadeInDown;
   }


  .back-to-blog {
    display: inline-flex;
    align-items: center;
    color: #008c45;
    font-weight: 700;
    font-size: 14px;
    text-decoration: none;
  }

  .back-to-blog:hover {
    color: #006633;
    text-decoration: none;
  }

  .article-image {
    width: 100%;
    max-height: 460px;
    overflow: hidden;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  }

  .article-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .article-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    margin-top: 22px;
    color: #999;
    font-size: 13px;
    font-style: italic;
  }

  .article-title {
    margin-top: 12px;
    font-size: 28px;
    line-height: 1.3;
  }

  .article-divider {
    border-top: 2px solid #f0f0f0;
    margin: 20px 0 24px;
  }

  .article-body {
    color: #000000;
    font-size: 18px;
    line-height: 1.9;
  }

  .article-body p {
    margin-bottom: 1.2em;
  }

  .article-body ul,
  .article-body ol {
    margin-bottom: 1.2em;
    padding-left: 1.6em;
  }

  .article-body a {
    color: #008c45;
    font-weight: 600;
  }

  .article-body blockquote {
    border-left: 4px solid #008c45;
    margin: 1.2em 0;
    padding: 4px 20px;
    color: #495057;
    font-style: italic;
    background: #f4f9f6;
  }

  .article-body img {
    max-width: 100%;
    height: auto;
    border-radius: 10px;
    margin: 1em 0;
  }

  .article-body h1,
  .article-body h2,
  .article-body h3 {
    margin-top: 1.2em;
    margin-bottom: 0.6em;
    font-weight: 700;
    color: #222;
  }

  /* Matches the WYSIWYG editor's font-size options (vue2-editor/Quill stores
     these as classes, not inline styles, so the public page needs its own
     matching CSS — Quill's own size CSS is scoped to .ql-editor only). */
  .article-body .ql-size-small {
    font-size: 0.75em;
  }

  .article-body .ql-size-large {
    font-size: 1.5em;
  }

  .article-body .ql-size-huge {
    font-size: 2.5em;
  }

  /* Embedded videos from the editor's Video button are a plain <iframe>
     with no width/height attributes, so they need explicit sizing here too
     (same reason as the ql-size rules above). */
  .article-body .ql-video {
    display: block;
    width: 100%;
    max-width: 100%;
    aspect-ratio: 16 / 9;
    height: auto;
    border: none;
    border-radius: 10px;
    margin: 1.2em 0;
  }

  .sidebar-card {
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.08);
    padding: 22px 18px;
  }

  .sidebar-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    margin-bottom: 20px;
  }

  .sidebar-title-bar {
    display: inline-block;
    width: 5px;
    height: 20px;
    background: #008c45;
    border-radius: 3px;
    margin-right: 10px;
  }

  .related-post {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px;
    border-radius: 10px;
    margin-bottom: 8px;
    text-decoration: none;
    color: inherit;
    transition: background 0.2s ease, transform 0.2s ease;
  }

  .related-post:hover {
    background: #f4f9f6;
    transform: translateX(4px);
    text-decoration: none;
    color: inherit;
  }

  .related-post-thumb {
    width: 64px;
    height: 64px;
    object-fit: cover;
    border-radius: 8px;
    flex-shrink: 0;
  }

  .related-post-body {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .related-post-title {
    font-weight: 700;
    font-size: 13px;
    color: #333;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.4;
  }

  .related-post-date {
    font-size: 11px;
    color: #aaa;
    margin-top: 4px;
  }

  .moto-office-section {
    max-height: none;
    height: auto;
    overflow: visible;
    padding-bottom: 40px;
  }

  .moto-office-section .parallax {
    height: auto;
    padding-bottom: 40px;
  }
</style>
